import { FC } from "react";

import Collaborator from "../../../@types/Collaborator";
import { formatCurrency } from "../../../utils/maskFormatMoney";

interface ApprovalCallaboratorProps {
  data: Collaborator;
  onClick?: (() => void) | undefined;
  isSelected?: boolean;
}

const ApprovalCallaborator: FC<ApprovalCallaboratorProps> = ({
  data,
  onClick,
  isSelected = false,
}) => {
  const getCaracterInitial = (name: string) => {
    const arrName = name.split(" ");
    return arrName[0][0] + arrName[arrName.length - 1][0];
  };

  return (
    <div className={`mb-1 ${isSelected ? 'bg-blue-100' : ''}`}>
      <div
        className={`flex flex-row h-14 justify-between items-center border rounded-md
                 border-gray-300 p-2 hover:cursor-pointer`}
        onClick={onClick}
      >
        <div className="flex flex-row justify-start items-center gap-8 w-4/5 text-left">
          <div className="flex w-9 h-9 rounded-full bg-color-text text-color-default justify-center items-center">
            {getCaracterInitial(data.name)}
          </div>
          {data.name}
        </div>
        {data.totalValue? formatCurrency(Number(data.totalValue)) : ''}
      </div>
    </div>
  );
};

export default ApprovalCallaborator;
